import dynamic from 'next/dynamic'

const PDFSection = dynamic(
  () => import(/* webpackChunkName: "PDFSection" */ 'pageSections/PDFSection/PDFSection'),
  { ssr: false, loading: () => <div>PDF Loading...</div> }
)

const PoliciesHero = dynamic(() =>
  import(/* webpackChunkName: "PoliciesHero" */ 'pageSections/Policies/PoliciesHero')
)

const PoliciesBody = dynamic(() =>
  import(/* webpackChunkName: "PoliciesBody" */ 'pageSections/Policies/PoliciesBody')
)

const ProductHero = dynamic(() =>
  import(/* webpackChunkName: "ProductHero" */ 'pageSections/ProductHero/ProductHero')
)

const MoloHero = dynamic(() =>
  import(/* webpackChunkName: "MoloHero" */ 'pageSections/MoloHero/MoloHero')
)

const WallOfFameHero = dynamic(() =>
  import(/* webpackChunkName: "MoloHero" */ 'pageSections/WallOfFame/WallOfFameHero/WallOfFameHero')
)

const AboutCloserStatement = dynamic(() =>
  import(
    /* webpackChunkName: "AboutCloserStatement" */ 'pageSections/About/AboutCloserStatement/AboutCloserStatement'
  )
)
const AboutEmployeeResourceGroups = dynamic(() =>
  import(
    /* webpackChunkName: "AboutEmployeeResourceGroups" */ 'pageSections/About/AboutEmployeeResourceGroups/AboutEmployeeResourceGroups'
  )
)
const AboutUsLeadership = dynamic(() =>
  import(
    /* webpackChunkName: "AboutUsLeadership" */ 'pageSections/About/AboutUsLeadership/AboutUsLeadership'
  )
)
const CardGrid = dynamic(() =>
  import(/* webpackChunkName: "CardGrid" */ 'pageSections/CardGrid/CardGrid')
)
const CloserStatement = dynamic(() =>
  import(/* webpackChunkName: "CloserStatement" */ 'pageSections/CloserStatement/CloserStatement')
)
const FeaturedStory = dynamic(() =>
  import(
    /* webpackChunkName: "FeaturedStory" */ 'pageSections/MemberStories/FeaturedStory/FeaturedStory'
  )
)
const ImageGridSection = dynamic(() =>
  import(
    /* webpackChunkName: "ImageGridSection" */ 'pageSections/MemberStories/ImageGridSection/ImageGridSection'
  )
)
const MemberStoriesCarousel = dynamic(() =>
  import(
    /* webpackChunkName: "MemberStoriesCarousel" */ 'pageSections/MemberStories/MemberStoriesCarousel/MemberStoriesCarousel'
  )
)
const MemberStoriesCloserStatement = dynamic(() =>
  import(
    /* webpackChunkName: "MemberStoriesCloserStatement" */ 'pageSections/MemberStories/MemberStoriesCloserStatement/MemberStoriesCloserStatement'
  )
)
const ARCloser = dynamic(() =>
  import(/* webpackChunkName: "ARCloser" */ 'pageSections/ARCloser/ARCloser')
)

const Faqs = dynamic(() => import(/* webpackChunkName: "Faqs" */ 'pageSections/Faqs/Faqs'))
const FaqsFdr = dynamic(() => import(/* webpackChunkName: "FaqsFdr" */ 'pageSections/Faqs/FaqsFdr'))

const ProblemStatement = dynamic(() =>
  import(
    /* webpackChunkName: "ProblemStatement" */ 'pageSections/ProblemStatement/ProblemStatement'
  )
)
const ByTheNumbers = dynamic(() =>
  import(/* webpackChunkName: "ByTheNumbers" */ 'pageSections/ByTheNumbers/ByTheNumbers')
)
const ProductCards = dynamic(() =>
  import(/* webpackChunkName: "ProductCards" */ 'pageSections/ProductCards/ProductCards')
)
const PhoneAndNumbers = dynamic(() =>
  import(/* webpackChunkName: "PhoneAndNumbers" */ 'pageSections/PhoneAndNumbers/PhoneAndNumbers')
)
const AboutUsVideo = dynamic(() =>
  import(/* webpackChunkName: "AboutUsVideo" */ 'pageSections/About/AboutUsVideo/AboutUsVideo')
)
const MoreResourcesCarousel = dynamic(() =>
  import(
    /* webpackChunkName: "MoreResourcesCarousel" */ 'pageSections/MoreResourcesCarousel/MoreResourcesCarousel'
  )
)
const TestimonialCarousel = dynamic(() =>
  import(
    /* webpackChunkName: "TestimonialCarousel" */ 'pageSections/TestimonialCarousel/TestimonialCarousel'
  )
)
const TestimonialCarouselV2 = dynamic(() =>
  import(
    /* webpackChunkName: "TestimonialCarouselV2" */ 'pageSections/TestimonialCarouselV2/TestimonialCarouselV2'
  )
)
const StoryBlocks = dynamic(() =>
  import(/* webpackChunkName: "StoryBlocks" */ 'pageSections/StoryBlocks/StoryBlocks')
)
const StoryVideoBlocks = dynamic(() =>
  import(
    /* webpackChunkName: "StoryBlocks" */ 'pageSections/StoryBlocks/StoryVideoBlocks/StoryVideoBlocks'
  )
)
const StoryBlocksAuthor = dynamic(() =>
  import(
    /* webpackChunkName: "StoryBlocksAuthor" */ 'pageSections/StoryBlocksAuthor/StoryBlocksAuthor'
  )
)
const AddressSection = dynamic(() =>
  import(/* webpackChunkName: "AddressSection" */ 'pageSections/AddressSection/AddressSection')
)
const PageTitle = dynamic(() =>
  import(/* webpackChunkName: "PageTitle" */ 'pageSections/PageTitle/PageTitle')
)
const PressKitDownload = dynamic(() =>
  import(
    /* webpackChunkName: "PressKitDownload" */ 'pageSections/PressKitSection/PressKitDownload/PressKitDownload'
  )
)
const PaginatedStoryGrid = dynamic(() =>
  import(
    /* webpackChunkName: "PaginatedStoryGrid" */ 'pageSections/PaginatedStoryGrid/PaginatedStoryGrid'
  )
)
const PaginatedArticlesGrid = dynamic(() =>
  import(
    /* webpackChunkName: "PaginatedArticlesGrid" */ 'pageSections/PaginatedArticlesGrid/PaginatedArticlesGrid'
  )
)
const SmsDisclosures = dynamic(() =>
  import(/* webpackChunkName: "SmsDisclosures" */ 'pageSections/SmsDisclosures/SmsDisclosures')
)
const MoloSection = dynamic(() =>
  import(/* webpackChunkName: "MoloSection" */ 'pageSections/MoloSection/MoloSection')
)
const CloserStatementApp = dynamic(() =>
  import(
    /* webpackChunkName: "CloserStatementApp" */ 'pageSections/CloserStatementApp/CloserStatementApp'
  )
)
const EmployeeStoriesGrid = dynamic(() =>
  import(
    /* webpackChunkName: "EmployeeStoriesGrid" */ 'pageSections/EmployeeStoriesGrid/EmployeeStoriesGrid'
  )
)

const EmployeeStoriesPolaroidCollage = dynamic(() =>
  import(
    /* webpackChunkName: "EmployeeStoriesPolaroidCollage" */ 'pageSections/EmployeeStories/EmployeeStoriesPolaroidCollage/EmployeeStoriesPolaroidCollage'
  )
)
const TestimonialFullBackgroundCarousel = dynamic(() =>
  import(
    /* webpackChunkName: "TestimonialFullBackgroundCarousel" */ 'pageSections/TestimonialFullBackgroundCarousel/TestimonialFullBackgroundCarousel'
  )
)
const PartnersForm = dynamic(() =>
  import(/* webpackChunkName: "PartnersForm" */ 'pageSections/PartnersForm/PartnersForm')
)
const EmailForm = dynamic(() =>
  import(/* webpackChunkName: "EmailForm" */ 'pageSections/EmailForm/EmailForm')
)
const FeaturedPressCarousel = dynamic(() =>
  import(
    /* webpackChunkName: "FeaturedPressCarousel" */ 'pageSections/Press/FeaturedPressCarousel/FeaturedPressCarousel'
  )
)
const MultiSlider = dynamic(() =>
  import(/* webpackChunkName: "MultiSlider" */ 'pageSections/MultiSlider/MultiSlider')
)
const DTICalculator = dynamic(() =>
  import(/* webpackChunkName: "DTICalculator" */ 'pageSections/DTICalculator/DTICalculator')
)
const DTIRadialCalculator = dynamic(() =>
  import(
    /* webpackChunkName: "DTIRadialCalculator" */ 'pageSections/DTIRadialCalculator/DTIRadialCalculator'
  )
)
const DebtAssessmentSection = dynamic(() =>
  import(
    /* webpackChunkName: "DebtAssessmentSection" */ 'pageSections/DebtAssessmentSection/DebtAssessmentSection'
  )
)
const ArticlesCarousel = dynamic(() =>
  import(
    /* webpackChunkName: "ArticlesCarousel" */ 'pageSections/ArticlesCarousel/ArticlesCarousel'
  )
)
const SkinnyForm = dynamic(() =>
  import(/* webpackChunkName: "SkinnyForm" */ 'pageSections/SkinnyForm/SkinnyForm')
)
const ValuePropsFull = dynamic(() =>
  import(/* webpackChunkName: "ValuePropsFull" */ 'pageSections/ValuePropsFull/ValuePropsFull')
)

const HaveMoreQuestions = dynamic(() =>
  import(
    /* webpackChunkName: "HaveMoreQuestions" */ 'pageSections/HaveMoreQuestions/HaveMoreQuestions'
  )
)
const TestimonialCarouselFull = dynamic(() =>
  import(
    /* webpackChunkName: "TestimonialCarouselFull" */ 'pageSections/TestimonialCarouselFull/TestimonialCarouselFull'
  )
)
const PromoCards = dynamic(() =>
  import(/* webpackChunkName: "PromoCards" */ 'pageSections/PromoCards/PromoCards')
)
const ProductDetailsTabs = dynamic(() =>
  import(
    /* webpackChunkName: "ProductDetailsTabs" */ 'pageSections/ProductDetailsTabs/ProductDetailsTabs'
  )
)

const DebtConsolidationSolutions = dynamic(() =>
  import(
    /* webpackChunkName: "DebtConsolidationSolutions" */ 'pageSections/DebtConsolidationSolutions/DebtConsolidationSolutions'
  )
)

const StatBarGrid = dynamic(() =>
  import(/* webpackChunkName: "StatBarGrid" */ 'pageSections/StatBarGrid/StatBarGrid')
)

const SubnavSection = dynamic(() =>
  import(/* webpackChunkName: "SubnavSection" */ 'components/SubnavSection/SubnavSection')
)

const StateListingHero = dynamic(() =>
  import(
    /* webpackChunkName: "StateListingHero" */ 'pageSections/StateListingHero/StateListingHero'
  )
)

const StateBodyRender = dynamic(() =>
  import(/* webpackChunkName: "StateBodyRender" */ 'pageSections/StateBodyRender/StateBodyRender')
)

const TrustpilotCarouselSection = dynamic(
  () =>
    import(
      /* webpackChunkName: "TrustpilotCarouselSection" */ 'pageSections/TrustpilotCarouselSection/TrustpilotCarouselSection'
    ),
  { ssr: false }
)

const PaginatedAuthorsList = dynamic(() =>
  import(
    /* webpackChunkName: "PaginatedAuthorsList" */ 'pageSections/PaginatedAuthorsList/PaginatedAuthorsList'
  )
)

const ResultHero = dynamic(() =>
  import(/* webpackChunkName: "ResultHero" */ 'pageSections/ResultHero/ResultHero')
)

const ResultComparison = dynamic(() =>
  import(
    /* webpackChunkName: "ResultComparison" */ 'pageSections/ResultComparison/ResultComparison'
  )
)

const PaginatedArticlesList = dynamic(() =>
  import(
    /* webpackChunkName: "PaginatedArticlesList" */ 'pageSections/PaginatedArticlesList/PaginatedArticlesList'
  )
)

const PaginatedBillsArticlesList = dynamic(() =>
  import(
    /* webpackChunkName: "PaginatedBillsArticlesList" */ 'pageSections/PaginatedBillsArticlesList/PaginatedBillsArticlesList'
  )
)

const CardInfo = dynamic(() =>
  import(/* webpackChunkName: "CardInfo" */ 'pageSections/CardInfo/CardInfo')
)

const ArticleListCarouselSection = dynamic(() =>
  import(
    /* webpackChunkName: "ArticleListCarouselSection" */ 'pageSections/ArticleListCarouselSection/ArticleListCarouselSection'
  )
)

const MainListArticlesCategory = dynamic(() =>
  import(
    /* webpackChunkName: "MainListArticlesCategory" */ 'pageSections/MainListArticlesCategory/MainListArticlesCategory'
  )
)

const PartnersRegisterForm = dynamic(() =>
  import(
    /* webpackChunkName: "PartnersRegisterForm" */ 'pageSections/PartnersRegisterForm/PartnersRegisterForm'
  )
)

const AchieveProContactForm = dynamic(() =>
  import(
    /* webpackChunkName: "AchieveProContactForm" */ 'pageSections/AchieveProContactForm/AchieveProContactForm'
  )
)

const ComparisonTable = dynamic(() =>
  import(/* webpackChunkName: "ComparisonTable" */ 'pageSections/ComparisonTable/ComparisonTable')
)

const PopUpSection = dynamic(() =>
  import(/* webpackChunkName: "PopUpSection" */ 'pageSections/PopUpSection/PopUpSection')
)

const TermList = dynamic(() =>
  import(/* webpackChunkName: "TermList" */ 'pageSections/TermList/TermList')
)

const MapSlider = dynamic(() =>
  import(/* webpackChunkName: "MapSlider" */ 'pageSections/MapSlider/MapSlider')
)

const PromiseSlider = dynamic(() =>
  import(/* webpackChunkName: "PromiseSlider" */ 'pageSections/PromiseSlider/PromiseSlider')
)

const TestimonialSlider = dynamic(() =>
  import(
    /* webpackChunkName: "TestimonialSlider" */ 'pageSections/TestimonialSlider/TestimonialSlider'
  )
)

const StandardSection = dynamic(() =>
  import(/* webpackChunkName: "StandardSection" */ 'pageSections/StandardSection/StandardSection')
)

const WallOfFameHighlights = dynamic(() =>
  import(
    /* webpackChunkName: "WallOfFameHighlights" */ 'pageSections/WallOfFame/WallOfFameHighlights/WallOfFameHighlights'
  )
)

const WallOfFameStories = dynamic(() =>
  import(
    /* webpackChunkName: "WallOfFameHighlights" */ 'pageSections/WallOfFame/WallOfFameStories/WallOfFameStories'
  )
)

const MessageMapper = dynamic(() =>
  import(/* webpackChunkName: "MessageMapper" */ 'pageSections/MessageMapper/MessageMapper')
)

const HeroBrandSection = dynamic(() =>
  import(/* webpackChunkName: "WallOfFameHighlights" */ 'pageSections/HeroBrand/HeroBrand')
)

const ReviewsSection = dynamic(() =>
  import(/* webpackChunkName: "ReviewsSection" */ 'pageSections/ReviewsSection/ReviewsSection')
)

const HelocCalculatorSection = dynamic(() =>
  import(
    /* webpackChunkName: "HelocCalculatorSection" */ 'pageSections/HelocCalculatorSection/HelocCalculatorSection'
  )
)

const SliderLanding = dynamic(() =>
  import(/* webpackChunkName: "SliderLanding" */ 'pageSections/SliderLanding/SliderLanding')
)

const HeroSection = dynamic(() =>
  import(/* webpackChunkName: "HeroSection" */ 'pageSections/HeroSection/HeroSection')
)

const TrustPilotStateWidget = dynamic(() =>
  import(
    /* webpackChunkName: "TrustPilotStateWidget" */ 'pageSections/TrustPilotStateWidget/TrustPilotStateWidget'
  )
)

const SectionFullBackground = dynamic(() =>
  import(
    /* webpackChunkName: "SectionFullBackground" */ 'pageSections/Employee/SectionFullBackground/SectionFullBackground'
  )
)

const DTIProductCards = dynamic(() =>
  import(/* webpackChunkName: "DTIProductCards" */ 'pageSections/DTIProductCards/DTIProductCards')
)

const BrandCloserStatementSection = dynamic(() =>
  import(
    /* webpackChunkName: "BrandCloserStatementSection" */ 'pageSections/BrandCloserStatementSection/BrandCloserStatementSection'
  )
)

const ShortFormSection = dynamic(() =>
  import(
    /* webpackChunkName: "ShortFormSection" */ 'pageSections/ShortFormSection/ShortFormSection'
  )
)

const GraphicCardList = dynamic(() =>
  import(
    /* webpackChunkName: "GraphicCardList" */ 'components/Graphic/GraphicCardList/GraphicCardList'
  )
)

const CrossSellWidget = dynamic(() =>
  import(/* webpackChunkName: "CrossSellWidget" */ 'pageSections/CrossSellWidget/CrossSellWidget')
)

const HeroDebt = dynamic(() =>
  import(/* webpackChunkName: "HeroDebt" */ 'pageSections/HeroDebt/HeroDebt')
)

const DebtPayoffCalculator = dynamic(() =>
  import(
    /* webpackChunkName: "DebtPayoffCalculator" */ 'pageSections/DebtPayoffCalculator/DebtPayoffCalculator'
  )
)

const DebtComparisonCalculator = dynamic(() =>
  import(
    /* webpackChunkName: "DebtComparisonCalculator" */ 'pageSections/DebtComparisonCalculator/DebtComparisonCalculator'
  )
)

const SimpleHero = dynamic(() =>
  import(/* webpackChunkName: "SimpleHero" */ 'pageSections/SimpleHero/SimpleHero')
)

const HeroJson = dynamic(() =>
  import(/* webpackChunkName: "HeroJson" */ 'pageSections/HeroJson/HeroJson')
)
const HeroJsonPro = dynamic(() =>
  import(/* webpackChunkName: "HeroJsonPro" */ 'pageSections/HeroJsonPro/HeroJsonPro')
)
const HeroJsonProAbout = dynamic(() =>
  import(
    /* webpackChunkName: "HeroJsonProAbout" */ 'pageSections/HeroJsonProAbout/HeroJsonProAbout'
  )
)
const GrowYourBusiness = dynamic(() =>
  import(
    /* webpackChunkName: "GrowYourBusiness" */ 'pageSections/GrowYourBusiness/GrowYourBusiness'
  )
)
const WordsFromLeadership = dynamic(() =>
  import(
    /* webpackChunkName: "WordsFromLeadership" */ 'pageSections/WordsFromLeadership/WordsFromLeadership'
  )
)
const NewsSection = dynamic(() =>
  import(/* webpackChunkName: "NewsSection" */ 'pageSections/NewsSection/NewsSection')
)

const LendingDebtSolutions = dynamic(() =>
  import(
    /* webpackChunkName: "LendingDebtSolutions" */ 'pageSections/LendingDebtSolutions/LendingDebtSolutions'
  )
)

const TestimonialTabs = dynamic(() =>
  import(/* webpackChunkName: "TestimonialTabs" */ 'pageSections/TestimonialTabs/TestimonialTabs')
)

const DisplayCase = dynamic(() =>
  import(/* webpackChunkName: "DisplayCase" */ 'pageSections/DisplayCase/DisplayCase')
)

const ProductQuiz = dynamic(() =>
  import(/* webpackChunkName: "ProductQuiz" */ 'pageSections/ProductQuiz/ProductQuiz')
)

const GleamWidget = dynamic(() =>
  import(/* webpackChunkName: "GleamWidget" */ 'pageSections/GleamWidget/GleamWidget')
)
const ExpandedContent = dynamic(() =>
  import(/* webpackChunkName: "ExpandedContent" */ 'pageSections/ExpandedContent/ExpandedContent')
)

const FaqsMultiple = dynamic(
  () => import(/* webpackChunkName: "FaqsMultiple" */ 'pageSections/FaqsMultiple/FaqsMultiple'),
  { ssr: false }
)

const SimpleAccordion = dynamic(() =>
  import(/* webpackChunkName: "SimpleAccordion" */ 'pageSections/SimpleAccordion/SimpleAccordion')
)

const PicturesGrid = dynamic(() =>
  import(/* webpackChunkName: "PicturesGrid" */ 'pageSections/PicturesGrid/PicturesGrid')
)

const BasicImage = dynamic(() =>
  import(/* webpackChunkName: "BasicImage" */ 'pageSections/BasicImage/BasicImage')
)

const BasicTable = dynamic(() =>
  import(/* webpackChunkName: "BasicTable" */ 'pageSections/BasicTable/BasicTable')
)

const BasicDisclaimer = dynamic(() =>
  import(/* webpackChunkName: "BasicDisclaimer" */ 'pageSections/BasicDisclaimer/BasicDisclaimer')
)

const MultiProductSection = dynamic(() =>
  import(
    /* webpackChunkName: "MultiProductSection" */ 'pageSections/MultiProductSection/MultiProductSection'
  )
)

const GridSection = dynamic(() =>
  import(/* webpackChunkName: "GridSection" */ 'pageSections/GridSection/GridSection')
)

const StatsGrid = dynamic(() =>
  import(/* webpackChunkName: "StatsGrid" */ 'pageSections/StatsGrid/StatsGrid')
)

// values in the componentMap need to match dropdown options in Contentful
export const pageSectionTypes = {
  AboutCloserStatement,
  AboutEmployeeResourceGroups,
  AboutUsLeadership,
  AboutUsVideo,
  AddressSection,
  ByTheNumbers,
  CardGrid,
  CloserStatement,
  DTIProductCards,
  EmployeeStoriesPolaroidCollage,
  Faqs,
  FaqsFdr,
  FeaturedPressCarousel,
  FeaturedStory,
  HeroSection,
  ImageGridSection,
  MemberStoriesCarousel,
  MemberStoriesCloserStatement,
  MoloHero,
  MoreResourcesCarousel,
  PageTitle,
  PaginatedArticlesGrid,
  PoliciesHero,
  PoliciesBody,
  PaginatedStoryGrid,
  PressKitDownload,
  ProblemStatement,
  ProductCards,
  ProductHero,
  StoryBlocks,
  TestimonialCarousel,
  SmsDisclosures,
  EmailForm,
  PhoneAndNumbers,
  MoloSection,
  MultiSlider,
  CloserStatementApp,
  EmployeeStoriesGrid,
  TestimonialFullBackgroundCarousel,
  StoryBlocksAuthor,
  StoryVideoBlocks,
  PartnersForm,
  DTICalculator,
  DTIRadialCalculator,
  DebtAssessmentSection,
  ArticlesCarousel,
  SectionFullBackground,
  SkinnyForm,
  SliderLanding,
  ValuePropsFull,
  TestimonialCarouselFull,
  TestimonialCarouselV2,
  PromoCards,
  ProductDetailsTabs,
  DebtConsolidationSolutions,
  StatBarGrid,
  ARCloser,
  SubnavSection,
  TrustpilotCarouselSection,
  PaginatedAuthorsList,
  ResultHero,
  ResultComparison,
  PaginatedArticlesList,
  PaginatedBillsArticlesList,
  CardInfo,
  ArticleListCarouselSection,
  MainListArticlesCategory,
  PartnersRegisterForm,
  AchieveProContactForm,
  ComparisonTable,
  'Pop-Up': PopUpSection,
  TermList,
  PromiseSlider,
  MapSlider,
  TestimonialSlider,
  StandardSection,
  WallOfFameHighlights,
  WallOfFameStories,
  WallOfFameHero,
  MessageMapper,
  HeroBrandSection,
  ReviewsSection,
  HelocCalculatorSection,
  HaveMoreQuestions,
  GraphicCardList,
  BrandCloserStatementSection,
  ShortFormSection,
  CrossSellWidget,
  HeroDebt,
  DebtPayoffCalculator,
  DebtComparisonCalculator,
  SimpleHero,
  HeroJson,
  HeroJsonPro,
  HeroJsonProAbout,
  GrowYourBusiness,
  WordsFromLeadership,
  NewsSection,
  LendingDebtSolutions,
  TestimonialTabs,
  DisplayCase,
  ProductQuiz,
  GleamWidget,
  ExpandedContent,
  PDFSection,
  StateListingHero,
  StateBodyRender,
  TrustPilotStateWidget,
  FaqsMultiple,
  SimpleAccordion,
  PicturesGrid,
  BasicImage,
  BasicTable,
  BasicDisclaimer,
  MultiProductSection,
  GridSection,
  StatsGrid,
}

export default pageSectionTypes
